<p-dialog
  [header]="'Common.Button.Crop' | translate"
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '620px', maxWidth: '95vw' }"
  [closable]="false"
  appendTo="body"
  (onHide)="close()"
>
  <ng-template pTemplate="content">
    <div class="image-cropper-container">
      <image-cropper
        *ngIf="imageBase64"
        [imageBase64]="imageBase64"
        [maintainAspectRatio]="!!aspectRatio"
        [aspectRatio]="aspectRatio || 1"
        [cropper]="cropperPosition"
        format="jpeg"
        (imageCropped)="onImageCropped($event)"
        (cropperReady)="onCropperReady($event)"
      ></image-cropper>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      class="p-button-secondary"
      [label]="'Common.Button.Cancel' | translate"
      (click)="close()"
    ></button>
    <button
      pButton
      type="button"
      [label]="'Confirm' | translate"
      (click)="confirm()"
    ></button>
  </ng-template>
</p-dialog>
